// "Did you mean …@gmail.com?" — spots likely typos in the domain of an
// email address (gnail.com, hotmial.com, gmail.con, yahoo.co,uk…). Plain
// code, no external service: compares the domain with common ones and
// suggests the closest if it's only a letter or two out. Some typo domains
// (gnail.com, hotmial.com) really exist and accept mail, so a DNS check
// alone can't catch them — this can.
const COMMON_DOMAINS = [
  'gmail.com', 'googlemail.com', 'hotmail.com', 'hotmail.co.uk', 'outlook.com', 'outlook.co.uk',
  'live.com', 'live.co.uk', 'msn.com', 'yahoo.com', 'yahoo.co.uk', 'ymail.com', 'icloud.com',
  'me.com', 'mac.com', 'aol.com', 'btinternet.com', 'sky.com', 'virginmedia.com', 'talktalk.net',
  'ntlworld.com', 'protonmail.com', 'proton.me', 'gmx.com', 'gmx.de', 'web.de', 'mail.com',
  't-online.de', 'orange.fr', 'free.fr', 'laposte.net', 'libero.it',
];
// Endings people mistype.
const TLD_FIXES = [[/\.con$/, '.com'], [/\.cmo$/, '.com'], [/\.ocm$/, '.com'], [/\.om$/, '.com'], [/\.comm$/, '.com'],
  [/\.co,uk$/, '.co.uk'], [/\.couk$/, '.co.uk'], [/\.co\.k$/, '.co.uk'], [/\.co\.ukk$/, '.co.uk'], [/\.net\.$/, '.net']];

// Letters to change / add / remove / swap to turn a into b.
const distance = (a, b) => {
  const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 1; j <= b.length; j++) d[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
  }
  return d[a.length][b.length];
};

// The corrected full address, or null if it looks fine.
export const suggestEmail = (email) => {
  const value = String(email || '').trim();
  const at = value.lastIndexOf('@');
  if (at < 1) return null;
  const local = value.slice(0, at);
  let domain = value.slice(at + 1).toLowerCase();
  if (!domain || COMMON_DOMAINS.includes(domain)) return null;

  for (const [re, fix] of TLD_FIXES) if (re.test(domain)) domain = domain.replace(re, fix);
  // "gmailcom" → "gmail.com"
  if (!domain.includes('.')) {
    const dotted = COMMON_DOMAINS.find(d => d.replace(/\./g, '') === domain);
    if (dotted) domain = dotted;
  }
  if (COMMON_DOMAINS.includes(domain)) return `${local}@${domain}`;

  let best = null;
  for (const d of COMMON_DOMAINS) {
    const dist = distance(domain, d);
    if (dist > 0 && dist <= (d.length > 9 ? 2 : 1) && (!best || dist < best.dist)) best = { d, dist };
  }
  return best ? `${local}@${best.d}` : null;
};
